import { useState, useEffect } from 'react';
import { fetchRecentTransactions } from '../services/transactionService';

export function useTransactions(account) {
  const [transactions, setTransactions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchTransactions() {
      if (!account) {
        console.log('No account provided to useTransactions');
        setIsLoading(false);
        return;
      }

      try {
        console.log('Fetching transactions for account:', account);
        const fetchedTransactions = await fetchRecentTransactions(account);
        console.log('Fetched transactions:', fetchedTransactions);
        setTransactions(fetchedTransactions);
        setError(null);
      } catch (err) {
        console.error('Error fetching transactions:', err);
        setError('Failed to fetch transactions. Please try again later.');
        setTransactions([]);
      } finally {
        setIsLoading(false);
      }
    }

    fetchTransactions();
  }, [account]);

  return { transactions, isLoading, error };
}